import { render } from "./AppFooter.vue?vue&type=template&id=2bf02913&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=2bf02913&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/momentum-generator/momentum-generator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf02913"]])

export default __exports__